import axios from 'axios';
import * as httpClient from './http-client';
import store from '../../storeClient';

const citiesByCodeCache = new Map();

function getFromCache(code) {
  return citiesByCodeCache.get(code) ?? null;
}

function setInCache(code, data) {
  if (code != null && data != null) {
    citiesByCodeCache.set(code, data);
  }
}

export default {
  getDestinations(words) {
    const { token } = store.getState().applicationState;
    return axios
      .get(`${process.env.RAZZLE_API_GEO}/ciudad?search=${words}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => res.data);
  },

  async getProvincias() {
    const { token } = store.getState().applicationState;
    return axios
      .get(`${process.env.RAZZLE_API_GEO}/provincia`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => res.data);
  },
  async getLocalidades() {
    const { token } = store.getState().applicationState;
    return axios
      .get(`${process.env.RAZZLE_API_GEO}/localidad`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => res.data);
  },
  async getCityByCode(code) {
    const fromCache = getFromCache(code);
    if (fromCache) {
      return Promise.resolve(fromCache);
    }
    const { token } = store.getState().applicationState;
    return axios
      .get(`${process.env.RAZZLE_API_GEO}/ciudad?codigo=${code}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setInCache(code, res.data);
        return res.data;
      });
  },
  async standAloneGetCityByCode(code) {
    return axios
      .get(`${process.env.RAZZLE_API_GEO}/ciudad?codigo=${code}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        return res.data;
      });
  },
  async getOriginByApi(token) {
    return httpClient
      .getWithToken(`${process.env.RAZZLE_API_PAQUETES}/OrigenDestino/obtener-origen`, token)
      .then((res) => {
        return res.data;
      });
  },
  async getDestinyByApi(code, token) {
    const origin = {
      codigo_origen: code,
    };
    return httpClient
      .postWithToken(
        `${process.env.RAZZLE_API_PAQUETES}/OrigenDestino/obtener-destino/`,
        origin,
        token
      )
      .then((res) => {
        return res.data;
      });
  },
  async getMonthByApi(ori, des, token) {
    const fecha = {
      codigo_origen: ori,
      codigo_destino: des,
    };
    return httpClient
      .postWithToken(
        `${process.env.RAZZLE_API_PAQUETES}/OrigenDestino/obtener-periodo`,
        fecha,
        token
      )
      .then((res) => {
        return res.data;
      });
  },
};
